import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { transactionsActions, transactionsSelectors } from 'app-components/flux/transactions';
import type CoreRootState from 'app-components/utils/redux-store/rootState';

import { useAppDispatch, useAppStore } from 'hooks/redux';
import { resetTTI } from 'utils/tti';

const TransactionsGarbageCollect = (): null => {
  const dispatch = useAppDispatch();
  const store = useAppStore<CoreRootState>();
  const { pathname } = useLocation();
  const pathnameL1 = pathname.split('/')[1];
  useEffect(() => {
    // reset transaction only on feature changes
    if (transactionsSelectors.getShouldResetHistoryWindow(store.getState())) {
      resetTTI();
      dispatch(
        transactionsActions.getTransactions(undefined, {
          context: 'transactions reset',
          props: { dateOnAfter: null },
        }),
      );
    }
  }, [pathnameL1, dispatch, store]);

  return null;
};
export default TransactionsGarbageCollect;
